import { Check as CheckIcon } from "@mui/icons-material";
import { StepConnector, stepConnectorClasses } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ModernConnector = styled(StepConnector)(() => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 16,
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderTopWidth: 2,
    borderColor: "#E6ECEA",
  },
  [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}`]: {
    borderColor: "#0E7A6E",
  },
  [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
    borderColor: "#0E7A6E",
  },
}));

const StepIconRoot = styled("div")(({ ownerState }) => ({
  width: 32,
  height: 32,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: 13,
  fontWeight: 700,
  transition: "all 0.2s ease",
  ...(ownerState.active && {
    backgroundColor: "#0E7A6E",
    color: "#fff",
    boxShadow: "0 0 0 4px rgba(14,122,110,0.15)",
  }),
  ...(ownerState.completed && {
    backgroundColor: "#0E7A6E",
    color: "#fff",
  }),
  ...(!ownerState.active &&
    !ownerState.completed && {
      backgroundColor: "#F3F5F4",
      color: "#98A6A0",
      border: "1px solid #E6ECEA",
    }),
}));

export const ModernStepIcon = (props) => {
  const { active, completed, icon } = props;
  return (
    <StepIconRoot ownerState={{ active, completed }}>
      {completed ? <CheckIcon sx={{ fontSize: 16 }} /> : icon}
    </StepIconRoot>
  );
};
